import { Layout } from "components"
export const MessageGroup = () => {
 return (
  <Layout>
   <h1 className="flex justify-center py-5 text-xl font-bold">Message Groups</h1>
  </Layout>
 )
}
